(() => {
  function initArticleToc(root = document) {
    const content = root.querySelector('#article-description__content');
    const section = content?.closest('.section-main-article');
    const links = section?.querySelectorAll('.logic-content .click-slide a');
    if (!links?.length || content.dataset.tocReady) return;
    content.dataset.tocReady = 'true';

    const headings = Array.from(content.querySelectorAll('h2')).filter(
      (heading) => !heading.closest('.inside-metablock')
    );
    const entries = Array.from(links).flatMap((link, index) => {
      const heading = headings[index];
      if (!heading) return [];

      if (!heading.id || document.querySelectorAll(`#${CSS.escape(heading.id)}`).length > 1) {
        const base = heading.textContent.trim().toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
        let id = base;
        let suffix = 2;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
      }

      link.hash = heading.id;
      link.textContent = heading.textContent.trim();
      return [{ heading, link, item: link.closest('.click-slide') }];
    });
    if (!entries.length) return;

    let activeEntry;
    let frame;
    const controller = new AbortController();
    const update = () => {
      frame = null;
      const styles = getComputedStyle(document.documentElement);
      const offset = Math.max(
        parseFloat(styles.scrollPaddingTop) || 0,
        (parseFloat(styles.getPropertyValue('--header-height-live')) || 0) + 16
      );
      let current = entries[0];
      for (const entry of entries) {
        if (entry.heading.getBoundingClientRect().top > offset + 1) break;
        current = entry;
      }
      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
        current = entries[entries.length - 1];
      }
      if (activeEntry === current) return;
      entries.forEach((entry) => {
        const active = entry === current;
        entry.item.classList.toggle('active', active);
        if (active) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      });
      activeEntry = current;
    };
    const scheduleUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', scheduleUpdate, { passive: true, signal: controller.signal });
    window.addEventListener('resize', scheduleUpdate, { signal: controller.signal });
    window.addEventListener('pageshow', scheduleUpdate, { signal: controller.signal });
    const observer = new ResizeObserver(scheduleUpdate);
    observer.observe(content);
    section.addEventListener('shopify:section:unload', () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      delete content.dataset.tocReady;
    }, { once: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initArticleToc(), { once: true });
  } else {
    initArticleToc();
  }
  document.addEventListener('shopify:section:load', (event) => initArticleToc(event.target));
})();
